module.exports = __webpack_public_path__ + "img/09_full.0ef79059.jpg";